var w4d = w4d || {};

w4d.footer_nav = {

    init: function () {
        this.mobile_footer_init();
        this.register_events();
    },

    /**
     * register_events - All events you want to register for this module
     *
     * @return {Undefined}
     */
    register_events: function () {
       window.addEventListener('resize', this.mobile_footer_init.bind(this));
    },

    /**
     * mobile_footer_init - Handle hidden menu in XS size (576px) footer
     *
     * @return {Undefined}
     */
    mobile_footer_init: function() {
        var mediaQueryXs = window.matchMedia('(max-width: 767px)');

        if (mediaQueryXs.matches) {
            document.querySelectorAll('.js-footer-menu').forEach((ul) => {
                if (!ul.querySelector('.js-footer-toggle')) {
                    ul.classList.add('w4d-footer__toggle-on');
                    const firstLiA = ul.querySelector('li:first-child a');

                    if(!firstLiA) return;

                    const firstLiText = firstLiA.innerText;

                    var toggleEl = document.createElement('div');
                    toggleEl.classList.add('w4d-footer__xs-toggle', 'js-footer-toggle');
                    toggleEl.innerText = firstLiText;

                    toggleEl.addEventListener('click', () => {
                        ul.classList.toggle('show');
                    });

                    ul.insertBefore(toggleEl, ul.firstChild);
                }
            });
        } else {
            document.querySelectorAll('.js-footer-menu').forEach((ul) => {
                var toggleEl = ul.querySelector('.js-footer-toggle');
                if (ul.classList.contains('show')) ul.classList.remove('show');
                if (ul.classList.contains('w4d-footer__toggle-on')) ul.classList.remove('w4d-footer__toggle-on');
                if (toggleEl) toggleEl.remove();
            })
        }
    }
}

window.addEventListener('load', function () {
    w4d.footer_nav.init();
})